import { render, staticRenderFns } from "./Tresiba.vue?vue&type=template&id=3b7f0e78&scoped=true&"
import script from "./Tresiba.vue?vue&type=script&lang=js&"
export * from "./Tresiba.vue?vue&type=script&lang=js&"
import style0 from "./Tresiba.vue?vue&type=style&index=0&id=3b7f0e78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7f0e78",
  null
  
)

export default component.exports